function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3916 4.17414L12.6224 1.1433C12.5383 0.999136 12.3999 0.894136 12.2383 0.85247C12.0774 0.81247 11.9049 0.835803 11.7616 0.921636L6.35327 4.16664L14.3916 4.17414Z",
  fill: "#43D190"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 4.99984C2.04167 4.99984 1.66667 4.62484 1.66667 4.1665C1.66667 3.70817 2.04167 3.33317 2.5 3.33317H5.30833L8.09167 1.6665H2.5C1.26667 1.6665 0.241667 2.5665 0.0416667 3.74984C0.025 3.8165 0 3.88317 0 3.95817V16.6665C0 18.0415 1.125 19.1665 2.5 19.1665H16.6667C17.5833 19.1665 18.3333 18.4165 18.3333 17.4998V15.8332H16.25C14.1833 15.8332 12.5 14.1498 12.5 12.0832C12.5 10.0165 14.1833 8.33317 16.25 8.33317H18.3333V6.6665C18.3333 5.74984 17.5833 4.99984 16.6667 4.99984H2.5ZM15.8333 3.33317C15.8333 2.4915 15.2083 1.7915 14.3917 1.68317L15.8333 4.1665V3.33317Z",
  fill: "#43D190"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.375 9.5835H16.25C14.8717 9.5835 13.75 10.7052 13.75 12.0835C13.75 13.4618 14.8717 14.5835 16.25 14.5835H19.375C19.72 14.5835 20 14.3035 20 13.9585V10.2085C20 9.8635 19.72 9.5835 19.375 9.5835ZM16.25 12.9168C15.79 12.9168 15.4167 12.5435 15.4167 12.0835C15.4167 11.6235 15.79 11.2502 16.25 11.2502C16.71 11.2502 17.0833 11.6235 17.0833 12.0835C17.0833 12.5435 16.71 12.9168 16.25 12.9168Z",
  fill: "#43D190"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.b8595cbe.svg";
export { ForwardRef as ReactComponent };